import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, input, Input, NgZone, OnDestroy, OnInit, signal, TemplateRef, viewChild, ViewChild } from '@angular/core';
import { CdkDragDrop, CdkDropList, copyArrayItem, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { EFConnectionBehavior, EFConnectionType, EFMarkerType, EFResizeHandleType, FCanvasComponent, FCreateConnectionEvent, FCreateNodeEvent, FDragStartedEvent, FDropToGroupEvent, FEventTrigger, FFlowComponent, FNodeDirective, FReassignConnectionEvent, FSelectionChangeEvent, FTriggerEvent, FZoomDirective, IFFlowStateNode } from '@foblex/flow';
import { A, BACKSPACE, C, CONTROL, DASH, DELETE, NUMPAD_MINUS, NUMPAD_PLUS, V } from '@angular/cdk/keycodes';
import { ConnectorModel } from '../webhook-interfaces/connectors';
import { NodeViewModel } from '../webhook-interfaces/node';
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';
import { NZ_MODAL_DATA, NzModalService } from 'ng-zorro-antd/modal';

import { WebHookConfirmPopupComponent } from './webhook-edit-confirm-popup/webhook-edit-confirm-popup.component';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { WebhookEditConfigurationComponent } from './webhook-edit-configuration/webhook-edit-configuration.component';
import { FlowData } from '../webhook-interfaces/flowdata';
import { FormGroup } from '@angular/forms';
import { FormServices } from 'src/app/services/form.services';
import { WebhookConfiguration, WebhookField } from '../webhook-interfaces/configuration';
import { NzMessageService } from 'ng-zorro-antd/message';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { ToolBoxModel } from '../webhook-interfaces/toolbox';
import { Flow, WorkFlowStepInput } from '../webhook-interfaces/flow';
import { WorkFlowCreatorNodeType } from '../webhook-types/workflow-creator-node-type';
import { ThemeService } from 'src/app/services/theme.service';
import { Subscription } from 'rxjs';
import { WebHookCommonServices } from '../webhook-services/webhook-commom.services';
import { ToolboxEvent } from './webhook-edit-toolbar/webhook-edit-toolbar.component';
import { DatePipe } from '@angular/common';
import { WebhookVariablesComponent } from '../webhook-variables/webhook-variables.component';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { environment } from 'src/environments/environment';
import { DebugInterface, WebhookDebugServices } from '../webhook-services/webhook-debug.services';
import { WebhookDebugLogComponent } from './webhook-debug-log/webhook-debug-log.component';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { NzFooterComponent } from 'ng-zorro-antd/layout';
import { FileLoaderServices } from 'src/app/services/FileLoader.services';
import { WebhookAIAssistantComponent } from './webhook-ia-assistant/webhook-ia-assistant.component';
import { resolve } from 'dns';


export interface IState {
    nodes: NodeViewModel[];
    connections?: ConnectorModel[];
}

export interface Version{
  sequence:number;
  active:string;
  versionDate:string;
  expression:string;
  status:string;
  lastChange?:string;
  name?:string;
}

@Component({
    selector: 'webhook-edit',
    templateUrl: './webhook-edit.component.html',
    styleUrl: './webhook-edit.component.scss',
    standalone: false,
    changeDetection:ChangeDetectionStrategy.OnPush,
    host:{
        '(document:keydown)': 'onKeyDown($event)',
        '(document:keyup)': 'onKeyUp($event)'
    }
})

export class WebhookEditComponent implements OnInit, OnDestroy {
  collapsedToolBar: boolean = false;
  drawerRefIA: NzDrawerRef<WebhookAIAssistantComponent, any>;
  sessionId:string =  null;
  subIA: Subscription;
  isCheckingDebug:boolean =  false;

  onCollapseToolBar(status: boolean): void {
    this.collapsedToolBar = status;
    localStorage.setItem("workflow.toolbar.collapsed",String(this.collapsedToolBar));

  }

  @ViewChild('fileUpload') fileUpload: ElementRef<HTMLInputElement>;
  drawerRef: NzDrawerRef<WebhookEditConfigurationComponent, any>;
  nodeProperties: object;
  connectionInputParameterProperties:WorkFlowStepInput[] = [];
  
  subFile: Subscription;
  sub1: Subscription;
  sub2: Subscription;
  sub3: Subscription;
  state:any[] = [];
  idconf:number= null;
  sequence:number = null;

  debugging:DebugInterface = null;
  lastDebugging:DebugInterface = null;
  /** idjob da execução corrente: token que invalida loops/mensagens de execuções anteriores */
  private currentDebugJob:number = null;
  /** job do loop de polling ativo (evita que um loop antigo libere a trava do novo) */
  private debugLoopToken:number = null;

  artefacts:ToolBoxModel[]= JSON.parse(localStorage.getItem('flow.toolbox.artefacts')) as ToolBoxModel[];
  connectors: ToolBoxModel[] = JSON.parse(localStorage.getItem('flow.toolbox.connector')) as ToolBoxModel[];
  
  configurations: {name:string, layout:WebhookConfiguration}[] = [];
  listOfVersion: Version[] = [];
  sub4: Subscription;
  selectedVersion: Version;
  canSave:boolean = false;
  debug:boolean = false;
  debugStatusInterval: NodeJS.Timeout;
  protected fTextStartOffset: string = '50%';
  codeCompany: number;
  controlPressed: boolean = false;
  @ViewChild('extraTpl') extraTpl!: TemplateRef<any>;
  @ViewChild(FZoomDirective) protected fZoom?: FZoomDirective;

  protected isZoomEnabled: boolean = false;
 
  protected readonly clipboard = signal<NodeViewModel[] | undefined>(undefined);


  protected readonly hasSelectedItems = signal<boolean>(false);

  // loading do fluxo (substitui o ngx-spinner): signal por baixo para
  // funcionar com OnPush sem markForCheck em cada ponto de uso
  private readonly _flowLoading = signal<boolean>(false);
  get flowLoading(): boolean { return this._flowLoading(); }
  set flowLoading(value: boolean) { this._flowLoading.set(value); }
  
  // Expor o enum para uso no template
  protected readonly WorkFlowCreatorNodeType = WorkFlowCreatorNodeType;
  
  constructor(
      private _changeDetectorRef: ChangeDetectorRef,
      private modal: NzModalService,
      private drawerService: NzDrawerService,
      private ls:LanguageServices,
      private messageService:NzMessageService,
      public ThemeService:ThemeService,
      private workFlowService:WebHookCommonServices,
      public datapipe:DatePipe,
      private notification: NzNotificationService,
      private uas:UserAuthenticationServices,
      private debugServices:WebhookDebugServices,
      private fileLoader:FileLoaderServices
  ) {
    
      const value = localStorage.getItem("workflow.toolbar.collapsed");
      this.collapsedToolBar = value === 'true'; 

      this.subFile = this.fileLoader.fileLoaded$.subscribe(content => {
        
        this.afterFileLoaded(content);
      });
      
  }
  
  
  @ViewChild('flowRef') flowRef!: FFlowComponent;
  @ViewChild('footerTpl', { static: false }) footerTpl?: TemplateRef<{}>;
  @ViewChild('copyInput', { static: false }) copyInputTemplate?: TemplateRef<{}>;

  nodes:NodeViewModel [] = [];
  
  flowData:FlowData = {
      codecompany:0,
      codemktp:3,
      codemktpdest:3,
      environment:1,
      idconf:5162,
      data:null,
      status:null,
      name: null,
  };

  @Input()selectedItem; 

  worker: Worker;
  

  public cBehavior: EFConnectionBehavior = EFConnectionBehavior.FIXED;
  public cType: EFConnectionType = EFConnectionType.SEGMENT;
  
  protected fCanvas = viewChild.required(FCanvasComponent);
  
  protected readonly eMarkerType = EFMarkerType;

  protected onLoaded(): void {
    //this.fCanvas().resetScaleAndCenter(false);
    if (this.nodes.length > 0) {
      this.centerCanvas(false);
    }
    
  }

  private centerCanvas(animated: boolean = false): void {
    setTimeout(() => this.fCanvas()?.resetScaleAndCenter(animated));
  }

  public connections: ConnectorModel[] = [];

  public reassignConnection(event: FReassignConnectionEvent): void {
    this.canSave = true;

    if (!event.newTargetId) {
    } else{
      this.connections = [ {key:StringUtils.UIDGerador(),  from: event.newSourceId || event.oldSourceId, to: event.newTargetId } ];
    }
    this._changeDetectorRef.detectChanges();
  }

  public addConnection(event: FCreateConnectionEvent): void {
    this.canSave = true;
    if(!event.fInputId) {
      return;
    }

    let ifComponent = this.isIfComponent(event.fOutputId);
    
    let key = StringUtils.UIDGerador();

    if ( ifComponent ){
        
        if (  event.fOutputId.endsWith("-true") ){
          key = key+"-true";
        }else{
          if (  event.fOutputId.endsWith("-false")){
            key = key+"-false";
          }else{
            return; 
          }
        }
    }


    this.connections.push({key:key, from: event.fOutputId, to: event.fInputId });
    
    this._changeDetectorRef.detectChanges();
  }

  isIfComponent(id:string){
    return this.nodes.filter(d=>d.key == id.split("_")[0] && d.type==WorkFlowCreatorNodeType.If).length > 0? true:false;
  }

  lenghtIfComponent(id:string){
    return this.connections.filter(d=>d.from == id ).length;
  }

  isNotIfNode(nodeType: WorkFlowCreatorNodeType): boolean {
    return nodeType !== WorkFlowCreatorNodeType.If;
  }

  isIfNode(nodeType: WorkFlowCreatorNodeType): boolean {
    return nodeType === WorkFlowCreatorNodeType.If;
  }

  isGroupNode(nodeType: WorkFlowCreatorNodeType): boolean {
    return nodeType === WorkFlowCreatorNodeType.While || nodeType === WorkFlowCreatorNodeType.ForEach;
  }

  
  public onKeyUp(event: KeyboardEvent): void {
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
      return;
    }
    switch (event.keyCode) {
      case CONTROL:
          this.controlPressed = false;
          break;
    }
  }

  public onKeyDown(event: KeyboardEvent): void {
    if (event.target instanceof HTMLInputElement || event.target instanceof HTMLTextAreaElement) {
      return;
    }
    switch (event.keyCode) {
      case DELETE:
        this.onRemoveItems();
        break;
      case NUMPAD_PLUS:
        // if (this.isCommandButton(event)) {
        //   this.fZoomDirective.zoomIn();
        // }
        break;
      case NUMPAD_MINUS:
      case DASH:
        // if (this.isCommandButton(event)) {
        //   this.fZoomDirective.zoomOut();
        // }
        break;
      case A:
        // if (this.isCommandButton(event)) {
        //   this.fFlowComponent.selectAll();
        // }
        break;
      case CONTROL:
        this.controlPressed = true;
        break;

      case CONTROL && C:
        this.copy();
      break;

      case CONTROL && V:
        this.paste();
      break;
    }
  }

  onRemoveItems() {
    
    if ( this.flowData.status != "DRAFT"){
      this.modal.error({
        nzTitle:this.ls.instant("workflow.error"),
        nzContent:this.ls.instant("workflow.remove.only.draft"),
        nzCentered:true
      })
      return;
    }

    this.canSave = true;

    var selection = this.flowRef.getSelection();

    if ( selection.fNodeIds.length === 0  && selection.fConnectionIds.length === 0) {
      return;
    }

    this.modal.confirm({
      nzTitle:  this.ls.instant('webhook.edit.remove.title'),
      nzClosable: false,
      nzContent: WebHookConfirmPopupComponent,
      nzData: { message: this.ls.instant('webhook.edit.remove.node.message',{sizeNodes:selection.fNodeIds.length}) },
      nzOkText: this.ls.instant('confirm'),
      nzOkDanger: true,
      nzCancelText: this.ls.instant('cancel'),
      nzOnOk: () => {
          const selection = this.flowRef.getSelection();
        
          for ( var sel of selection.fNodeIds) {

            this.connections = this.connections.filter(
              conn => !(conn.from.startsWith(sel) || conn.to.startsWith(sel))
            );

            const nodeIndex = this.nodes.findIndex(n => n.key === sel);
            if (nodeIndex !== -1) {
              this.nodes.splice(nodeIndex, 1);
            }
          }

          for ( var sel of selection.fConnectionIds) {
            this.connections = this.connections.filter(
              conn =>  !(conn.key === sel )
            );
          }

          this._changeDetectorRef.detectChanges();
      },
    })
    
  }

  onSelectionChange(event:FSelectionChangeEvent ): void {

  }

  addNode(event: FCreateNodeEvent): void {

      if ( this.flowData.status != "DRAFT"){
        this.modal.error({
          nzTitle:this.ls.instant("workflow.error"),
          nzContent:this.ls.instant("workflow.add.only.draft"),
          nzCentered:true
        })
        return;
      }


      this.canSave = true;
      let id = StringUtils.UIDGerador();

      let outNode = this.createOutputNode(id, event.data.type);
      let inputNode = this.createInputNode(id);

      let node = {
          key: id,
          componentName:event.data.text,
          name: '',
          properties:{},
          position: { x: event.rect.x, y: event.rect.y },
          size: { width: event.data.size.width, height:  event.data.size.height },
          inputs: inputNode,
          outputs: outNode,
          multiple: false,
          content: '',
          active:true,
          type: WorkFlowCreatorNodeType[event.data.type],
          color: event.data.color,
          panelWidth: event.data.panelWidth,
          icon: event.data.icon,
          svg:event.data.svg
      }
      this.nodes.push(node);
      
      this.editNodeConfiguration(node,true);

      this._changeDetectorRef.detectChanges();
  }

  createInputNode(id:string){
    return [id+'_in-top', id+'_in-bottom',id+'_in-left',id+'_in-right'];
  }

  // createOutputNode(id:string, dataType:string) {
  //   let outNode =  [id+'_out-top', id+'_out-bottom',id+'_out-left',id+'_out-right'];
  //   if (WorkFlowCreatorNodeType[dataType] == WorkFlowCreatorNodeType.If){
  //     outNode =  [id+'_out-right-true',id+'_out-right-false'];
  //   }
  //   return outNode;
  // }

  dropToGroup(event:FDropToGroupEvent): void {
    if ( this.flowData.status != "DRAFT"){
      this.modal.error({
        nzTitle:this.ls.instant("workflow.error"),
        nzContent:this.ls.instant("workflow.dragdrop.only.draft"),
        nzCentered:true
      })
      return;
    }

    this.canSave = true;
    event.fNodes.forEach(evev => {
      this.nodes.find(node => node.key === evev).parentId = event.fTargetNode;
    });

    this._changeDetectorRef.detectChanges();
  }
  

  findNodeById(id: string):IFFlowStateNode {
    const state = this.flowRef.getState();
    return state.nodes.find(node => node.id === id);
  }


  editNodeConfiguration(node: NodeViewModel, isNew:boolean = false): void {

      if ( this.flowData.status != "DRAFT" ){
        this.modal.error({
          nzTitle:this.ls.instant("workflow.error"),
          nzContent:this.ls.instant("workflow.edit.only.draft"),
          nzCentered:true
        })
        return;
      }
      
      this.nodeProperties = JSON.parse(JSON.stringify(node.properties));
      if (node) {

           this.drawerRef = this.drawerService.create({
              nzTitle: this.ls.instant(node.componentName),
              nzContent: WebhookEditConfigurationComponent,
              nzWidth: node.panelWidth==null?"60%": node.panelWidth,
              nzMaskClosable: false,
              nzKeyboard: false,
              nzClosable: false,
              nzData: {
                  node: node,
                  nodes: this.nodes,
                  connections: this.connections,
                  flowData: this.flowData,
                  configuration:this.getLayoutConfiguration(node.type),
                  configurations:this.configurations,
                  isNew:isNew
              },
              nzFooter:this.footerTpl
          });

          this.sub4 = this.drawerRef.afterClose.subscribe(() => {
              
              this.flowRef.clearSelection();
              this._changeDetectorRef.detectChanges();
          });
       }
  }
  
  getLayoutConfiguration(type: WorkFlowCreatorNodeType): any {
      
      var layoutName = this.getToolBox(type).layoutName;
      if ( layoutName != null ){
          let layoutConf = this.configurations.find(d=>d.name == layoutName);
          if ( layoutConf != null ){
            return layoutConf.layout;
          }
      }

      return null;
  }
  
  getToolBox(type: WorkFlowCreatorNodeType): ToolBoxModel {
      var toolBoxModel:ToolBoxModel =  this.artefacts.find(d=>WorkFlowCreatorNodeType[d.type] == type);
      if ( toolBoxModel == null ){
          toolBoxModel =  this.connectors.find(d=>WorkFlowCreatorNodeType[d.type] == type);
      }

      
      return toolBoxModel;
  }

  close(){
    
    let node:NodeViewModel = this.drawerRef.getContentComponent().node;
    
    if ( node!= null ){
      let index = this.nodes.findIndex(d=>d.key==node.key);
      
      let isNew = this.drawerRef.getContentComponent().isNew;
      if ( isNew ){
        this.nodes.splice(index,1);
      }else{
        this.nodes[index].properties = this.nodeProperties;
      }      
    }

    let connection:ConnectorModel = this.drawerRef.getContentComponent().connection;

    if ( connection!=null){
        let index = this.connections.findIndex(d=>d.key == connection.key);
        this.connections[index].inputParameters = this.connectionInputParameterProperties;
    }

    this.drawerRef.close();
  }

  onVersionChange(event:Version){
    this.flowRef.clearSelection();
    this.activeFlow(event);
    
  }

  protected reloadingFlow = false;

private reloadFlow(): void {
    this.reloadingFlow = true;
    this._changeDetectorRef.detectChanges();   // remove o <f-flow> do DOM
    setTimeout(() => {
        this.reloadingFlow = false;
        this._changeDetectorRef.detectChanges(); // remonta limpo com os IDs novos
        this.centerCanvas(false);
    });
}

  save(){
      
      var configuration:WebhookConfiguration = this.drawerRef.getContentComponent().configuration;

      let object = {};
      let hasError = false;

      var form:FormGroup = this.drawerRef.getContentComponent().form;
      
      let editingfields = configuration.fields;
      let unsavedForm = this.workFlowService.extractTaggedFieldPaths(editingfields, []).filter(p=>p.field['editing'] == true);

      if ( unsavedForm != null && unsavedForm.length > 0 ){
          let message:string = '';
          for ( var f of unsavedForm ){
            message = message + '<br/>' + this.ls.instant(f.field.label);
          }
          this.messageService.error(this.ls.instant('workflow.edit.save.error',{fields:message}));
          return;
      }

      if ( form.invalid ){
        var fields:WebhookField[]  = configuration.fields;
        this.workFlowService.showError(fields, form);
        hasError = true;
      }else{
          object = ObjectUtil.deepMerge(object,form.getRawValue());
      }
      
      if ( !hasError){
        let node:NodeViewModel = this.drawerRef.getContentComponent().node;
        if ( node != null ){
          let index = this.nodes.findIndex(d=>d.key==node.key);
          let newObject = ObjectUtil.deepMerge(this.nodes[index],object);
          if ( object['properties'] !=null){
            newObject['properties'] = object['properties'];
          }
          

          this.nodes[index] = newObject as NodeViewModel;

          this.nodes = [...this.nodes];       
          this.drawerRef.close();
          this.reloadFlow();  

          if ( this.flowData.active=="S"){
            this.showCreateNewVersionConfimation();
          }else{
            this.saveFlow(false);
          }
        }

        let connection:ConnectorModel = this.drawerRef.getContentComponent().connection;

        if ( connection!= null ){
            let index = this.connections.findIndex(d=>d.key==connection.key);
            let newObject = ObjectUtil.deepMerge(this.connections[index],object);
            
            this.connections[index] = newObject as ConnectorModel;
          
            this.connections = [...this.connections];
            this.drawerRef.close();
            this.reloadFlow();  

            if ( this.flowData.active=="S"){
              this.showCreateNewVersionConfimation();
            }else{
              this.saveFlow(false);
            }
        }
        
      }

  }

  showCreateNewVersionConfimation() {
    this.modal.warning({
        nzTitle:this.ls.instant('workflow.save.newversion.title'),
        nzContent:this.ls.instant('workflow.save.newversion.question'),
        nzOkText: this.ls.instant('confirm'),
        nzOkDanger: true,
        nzCancelText: this.ls.instant('cancel'),
        nzOnOk: () => {
          this.saveFlow(true);
        }
      });
  }

  getSplit(to:string){
    if (to) {
      const suffixes = [
        '_out-top',
        '_out-bottom',
        '_out-left',
        '_out-right',
        '_in-top',
        '_in-bottom',
        '_in-left',
        '_in-right'
      ];

      for (const suffix of suffixes) {
        if (to.endsWith(suffix)) {
          return to.split(suffix)[0];
        }
      }
    }

    return '';
  }

  openConnectionConfiguration(event, connection:ConnectorModel){
      this.openDrwayerConfiguration(connection);        
  }

  openDrwayerConfiguration(connection:ConnectorModel){

    if ( this.flowData.status != "DRAFT" ){
        this.modal.error({
          nzTitle:this.ls.instant("workflow.error"),
          nzContent:this.ls.instant("workflow.edit.only.draft"),
          nzCentered:true
        })
        return;
      }

      let to = connection.to!=null?this.getSplit(connection.to): '';
      let toNode = this.nodes.find(d=>d.key == to);
      if ( toNode == null || toNode.inputParameters==null || toNode.inputParameters.length == 0 ){
        return; //todo colocar mensagem
      }
      
      if (connection) {
              
            if ( connection.inputParameters!=null ){
              this.connectionInputParameterProperties = JSON.parse(JSON.stringify(connection.inputParameters));
            }

            if ( toNode.inputParameters.length > 0 ){
              toNode.inputParameters.forEach(par=>{
                let parName = par.name;
                if ( par.name!= null ){
                  parName = par.name.startsWith("@")?par.name:"@"+par.name;
                }
                if ( connection.inputParameters != null ){
                  let index = connection.inputParameters.findIndex(d=>d.name==par.name);
                  
                  if ( index == -1 ){
                    connection.inputParameters.push({name:parName,type:null,value:null})
                  }
                }else{
                  connection.inputParameters = [{name:parName,type:null,value:null}];
                }
             })
            }

            this.drawerRef = this.drawerService.create({
              nzTitle: this.ls.instant('workflow.connection.title'),
              nzContent: WebhookEditConfigurationComponent,
              nzWidth: "60%",
              nzMaskClosable: false,
              nzKeyboard: false,
              nzClosable: false,
              nzData: {
                  connection: connection,
                  flowData: this.flowData,
                  configuration:this.configurations.find(d=>d.name=='flow.form.connection').layout,
                  configurations:this.configurations,
                  nodeToConnection: toNode,
                  isConnection:true
              },
              nzFooter:this.footerTpl
          });

          this.sub4 = this.drawerRef.afterClose.subscribe(() => {
              this.flowRef.clearSelection();
              this._changeDetectorRef.detectChanges();
          });
       }

  }

  saveFlow(createNew:boolean, nodes:NodeViewModel[] = null, connections:ConnectorModel[] = null) {
    
    this.flowLoading = true;
    let newObject = {
        steps: this.nodes,
        connectors:this.connections
    };

    if ( nodes != null ){
      newObject.steps = nodes;
    }

    if ( nodes != null ){
      newObject.connectors = connections;
    }
    
    let sequence = createNew ? (this.listOfVersion== null || this.listOfVersion.length==0)? 1 : Math.max(...this.listOfVersion.map(d=>d.sequence))+1 : this.flowData.sequence; 

    let ob = {
        entityName:"Mktpcfi",
        IDCONF:this.flowData.idconf,
        EXPRESSION: JSON.stringify(newObject),
        NAME: this.flowData.name,
        ACTIVE:"N",
        SEQUENCE:sequence
    }
    
    return new Promise((resolve,reject)=>{
        this.workFlowService.saveFlow(ob).then((con:any)=>{
          
          this.flowData.sequence = con["SEQUENCE"];
          this.flowData.active = con["ACTIVE"];
          this.flowData.name = con["NAME"];
          this.flowData.status = "DRAFT";
          this.flowData.data = newObject as Flow;
          
          this.nodes= newObject.steps;
          this.connections= newObject.connectors;

          let version = this.listOfVersion.find(d=>d.sequence==this.flowData.sequence);
          if ( version!= null ){
            version.active = this.flowData.active;
            version.status = this.flowData.status;
            version.expression = JSON.stringify(newObject);
            version.lastChange = con["RECMODIFYON"];
            version.versionDate = con["DTFORCE"];
            version.name = this.flowData.name;
          }
          
          if ( createNew ){
            this.messageService.success(this.ls.instant("workflow.success.created2",{version:this.flowData.sequence}));//Fluxo alterado com sucesso.");
            this.workFlowService.loadFlow(this.flowData.idconf).then(d=>{
              this.resolveFlow(d);
              if ( this.listOfVersion.length > 0 ){
                
                let newVersion = this.listOfVersion.find(d=>d.sequence==(this.flowData.sequence==null?1:this.flowData.sequence));
                this.activeFlow(newVersion);
              }
              
              this.flowLoading = false;
            }).catch(error=>{
              this.flowLoading = false;
              throw error;
            });
          }else{
            this.canSave = false;
            this.flowLoading = false;
          }
          resolve(true);
          this.flowRef.clearSelection();
          this._changeDetectorRef.detectChanges();
        },error=>{
            this.flowLoading = false;
            this.messageService.error(error.message);
            reject(error);
            this.flowRef.clearSelection();
            this._changeDetectorRef.detectChanges();
        });
    });
      
  }

  undo(){

  }

  getLabel(version:Version): any {
    // cores via tokens do tema: legíveis no claro/moderno E no dark/vault
    if ( version.status == "ACTIVE" ){
      return {
          label:this.ls.instant('workflow.version.active',{version:version.sequence, date:version.versionDate==null?"":version.versionDate}) +  (version.name!=null? ' | '+version.name:'' ),
          color:"var(--tem-success)",
          name: version.name
      }
    }else{
      if ( version.status == "DRAFT" ){
        return {
          label:this.ls.instant('workflow.version.draft',{version:version.sequence, dtalter:version.lastChange})+ (version.name!=null? ' | '+version.name:'' ),
          color:"var(--tem-ink)",
          name: version.name
        }
      }else{
          return {
            label:this.ls.instant('workflow.version.inactive',{version:version.sequence, date:version.versionDate==null?"":version.versionDate}) +  (version.name!=null? ' | '+version.name:'' ),
            color:"var(--tem-danger)",
            name: version.name
          }
      }

    }
  }

    onDragEnded(event){
      this.canSave = true;
      this._changeDetectorRef.detectChanges();
      let newObject = {
          steps: this.nodes,
          connectors:this.connections
      }
    }

   protected copy(): void {
      const selection = this.flowRef.getSelection();
      const nodeIds = selection.fNodeIds ?? [];
      const connectionIds = selection.fConnectionIds ?? [];
      if (!nodeIds.length && !connectionIds.length) return;
      this._copyInternalSimple(nodeIds);
      this.messageService.success(this.ls.instant("copy.clipboard"));
    }

    private _copyInternalSimple(nodeIds: string[]){
       const nodes:NodeViewModel[] = this.nodes.filter((n) => nodeIds.includes(n.key));
       this.clipboard.set(ObjectUtil.deepClone(nodes));
    }

    // protected paste(): void {
    //   const clip = this.clipboard();
    //   if (!clip?.length) return;

    //   const offset = 40;

    //   for (const node of clip) {
    //     node.key = StringUtils.UIDGerador();
    //     let outNode = this.createOutputNode(node.key, node.type);
    //     let inputNode = this.createInputNode(node.key);

    //     node.outputs = outNode;
    //     node.inputs = inputNode;
    //     node.name = this.ls.instant("copy")+" "+ this.ls.instant("of")+" "+node.name;
    //     node.position= { x: node.position.x + offset, y: node.position.y + offset };
    //     this.nodes.push(node);
    //   }

    //   this.flowRef.clearSelection();

    // }
  
    
  
    onPositionChange(pos: { x: number; y: number }, node:NodeViewModel) {
      this.canSave = true;
      if ( this.selectedVersion.status != "DRAFT" ){
        this.messageService.error(this.ls.instant('webhook.edit.node.position.notdraft'));
        return;
      }else{
        node.position = pos;
      }
    }

    

    onSizeChange(pos: { width: number; height: number }, node:NodeViewModel) {
      this.canSave = true;
      if ( this.selectedVersion.status != "DRAFT" ){
        this.messageService.error(this.ls.instant('webhook.edit.node.position.notdraft'));
        return;
      }else{
        node.size = pos;
      }
      
    }

    debugBoxAction(event:ToolboxEvent){
        
        if ( event.action == "startFlow"){
          if ( this.flowData.codecompany == 0 && (this.codeCompany== null || this.codeCompany == 0)) {
              this.messageService.error(this.ls.instant('webhook.edit.debug.companyrequired'));
              return;
          }

          this.codeCompany = this.flowData.codecompany == 0 ? this.codeCompany : this.flowData.codecompany;

          this.saveFlow(false).then(d=>{
            this.flowLoading = true;
            this.workFlowService.startFlow(this.flowData.idconf, this.codeCompany, this.selectedVersion.sequence).then(d=>{
                
                let idjob:number = d['idjob'];
                let threadName:string = d['threadName'];
                this.debugging = {
                    idjob: idjob,
                    debugging: 'debugging',
                    threadName: threadName
                }
                this.debugServices.updateDebug(this.debugging);

                this.createWorkerDebug();
                
                let title = this.ls.instant('workflow.debug.started')
                let message = this.ls.instant('workflow.debug.message',{idjob:idjob, threadName:threadName})
                this.notification.create('success',title,message);

            }).catch(error=>{
              GlobalErrorHandler.showError(error);
            }).finally(()=>{
              this.flowLoading = false;
            });
          });
          
        }else{
          if ( event.action == "changeCompany"){
              this.codeCompany = event.data;
          }else{
            if ( event.action == "continueFlow"){
              if ( this.debugging?.debugging == 'STEPPING'){
                let key:string = this.debugging?.status.key;
                this.workFlowService.continueFlow(this.debugging.idjob,key).then(value=>{
                    if ( this.debugging != null ){
                      this.debugging.debugging = 'DEBUGGING';
                      this.debugServices.updateDebug(this.debugging);
                    }
                }).catch(error=>{
                  this.messageService.error(error.message);
                });
              }
            }else{
              if ( event.action == "stopFlow"){
                  let threadName:string = this.debugging?.threadName
                  this.workFlowService.stopFlow(threadName).then(value=>{
                      // apenas SINALIZA a parada: quem encerra é o loop, que
                      // preserva o último pacote de logs em lastDebugging
                      if ( this.debugging != null ){
                        this.debugging.debugging = 'STOPPED';
                        this.debugServices.updateDebug(this.debugging);
                      }

                      // sem loop ativo ninguém vai finalizar — finaliza aqui
                      if ( !this.isCheckingDebug ){
                        this.finishDebug();
                      }
                  }).catch(error=>{
                    this.messageService.error(error.message);
                  });

              }
            }
          }
          
        }
    }

    toolBoxAction(event:ToolboxEvent){
        if (event.action == 'deploy'){
          if ( this.flowData.status != "DRAFT" ){
              this.messageService.error(this.ls.instant('webhook.edit.deploy.alreadyactive'));
              return;
          }
          
          this.modal.confirm({
            nzTitle: this.ls.instant('webhook.edit.deploy.title'),
            nzContent: this.ls.instant('webhook.edit.deploy.question',{version:this.flowData.sequence}),
            nzOkText: this.ls.instant('confirm'),
            nzOkDanger: true,
            nzCancelText: this.ls.instant('cancel'),
            nzOnOk: () => {
              this.deployFlow();
            }
          });
        }else if (event.action == 'variables') {
            this.modal.create({
                nzTitle: this.ls.instant('webhook.variables.title'),
                nzContent: WebhookVariablesComponent,
                nzWidth: '90%',
                nzMaskClosable: false,
                nzKeyboard: false,
                nzClosable: true,
                nzData: {
                    flowData: this.flowData,
                },
                nzFooter:null,
                nzCentered: true                
              });
        }else if (event.action == 'log') {
            this.modal.create({
                nzTitle: this.ls.instant('webhook.log.title'),
                nzContent: WebhookDebugLogComponent,
                nzWidth: '90%',
                nzStyle: { top: '5px', maxHeight: '100vh', display: 'flex','flex-direction': 'column','max-height': 'calc(100% - 10px)' },
                nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
                nzMaskClosable: false,
                nzKeyboard: false,
                nzClosable: true,
                nzData: {
                    flowData: this.flowData,
                },
                nzFooter:null,
                nzCentered: false                
              });
        
        }else if ( event.action=='copy' || event.action =='edit'){

            this.modal.confirm({
                nzTitle:  event.action=='copy' ? this.ls.instant('workflow.copy.title.name') : this.ls.instant('workflow.edit.step.name'),
                nzContent: this.copyInputTemplate,
                nzMaskClosable: false,
                nzKeyboard: false,
                nzClosable: true,
                
                nzData: {
                    flowData: this.flowData,
                },
                nzOkText:this.ls.instant('confirm'),
                nzCancelText:this.ls.instant('cancel'),  
                nzCentered: true, 
                nzOnOk: () => {
                  return new Promise<boolean>((resolve) => {
                      if ( this.flowData.name == null || this.flowData.name.trim() == ''){
                        this.messageService.error(this.ls.instant('workflow.copy.name.required'));
                        resolve(false);
                      }else{
                        this.saveFlow(event.action=='copy'?true:false).then(d=>{
                          if(event.action=='copy'){
                              this.messageService.success(this.ls.instant('workflow.copy.success',{name:this.flowData.name}));
                          }
                          resolve(true);
                        });
                        
                      }
                    }).catch(() => console.log('Oops errors!'))
                    
                }
              });
            
        }else if (event.action == 'debugon') {
              this.debug = true;
        }else if ( event.action == 'debugoff'){
              this.debug = false;
        }else if ( event.action == 'export'){
            this.workFlowService.exportFlow(this.flowData.data, this.selectedVersion, this.flowData);
        }else if ( event.action == 'import'){
            this.clickUpLoadFlow();
            
            
        }

    } 

    clickUpLoadFlow(){
      const input = this.fileUpload.nativeElement;
      input.value = '';
      input.click();
    }

    afterFileLoaded(content){
        try{
            let version:Flow = JSON.parse(content);
            
             this.modal.warning({
              nzTitle:this.ls.instant('workflow.save.newversion.title'),
              nzContent:this.ls.instant('workflow.save.newversion.question'),
              nzOkText: this.ls.instant('confirm'),
              nzOkDanger: true,
              nzCancelText: this.ls.instant('cancel'),
              nzOnOk: () => {
                this.saveFlow(true,version.steps, version.connectors);
              }
            });
            
        }catch(exception){
          this.messageService.error(exception);
        }
        
    }

    deployFlow() {
      this.flowLoading = true;
      let publishedVersion:Version = this.listOfVersion.find(d=>d.active=="S");

      let newObject = { 
          entityName:"Mktpcfi",
          IDCONF:this.flowData.idconf,
          SEQUENCE: publishedVersion == null? this.flowData.sequence : publishedVersion.sequence ,
          ACTIVE:"N",
      }

      this.workFlowService.saveFlow(newObject).then((con:any)=>{
          let newObject = { 
            entityName:"Mktpcfi",
            IDCONF:this.flowData.idconf,
            SEQUENCE: this.flowData.sequence,
            ACTIVE:"S",
            NAME: this.flowData.name,
            DTFORCE: this.datapipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss.SSS')
          }
            this.workFlowService.saveFlow(newObject).then((con:any)=>{
                this.flowData.active = "S";
                this.flowData.status = "ACTIVE";
                this.workFlowService.loadFlow(this.flowData.idconf).then(d=>{
                    this.resolveFlow(d);
                    this.activeFlow(this.listOfVersion.find(d=>d.sequence==this.flowData.sequence));
                    this._changeDetectorRef.detectChanges();
                    this.messageService.success(this.ls.instant('webhook.edit.deploy.success',{version:this.flowData.sequence}));
                    this.flowLoading = false;
                }).catch(error=>{
                    this.messageService.error(error.message);
                    this.flowLoading = false;  
                });
                this.flowLoading = false;
            }).catch(error=>{
                this.flowLoading = false;
                this.messageService.error(error.message);
            });

        this.flowLoading = false;
      }).catch(error=>{
          this.flowLoading = false;
          this.messageService.error(error.message);
      });      

    }


    getExecutionDebug(node:NodeViewModel){
      if ( this.debugging!= null && this.debugging.status != null){
          if ( this.debugging.status.key!=null){
            if ( this.debugging.status.key == node.key){
              if ( this.debugging.status.status == "RUNNING"){
                return "running-class";
              }
              if ( this.debugging.status.status == "STEPPING"){
                return "stepping-class";
              }
              return ''
            }
          }
      }
    }


    ngOnDestroy(): void {
      if ( this.sub1 != null ){
        this.sub1.unsubscribe();
      }
      if ( this.sub2 != null ){
        this.sub2.unsubscribe();
      }
      if ( this.sub3 != null ){
        this.sub3.unsubscribe();
      }
      if ( this.sub4 != null ){
        this.sub4.unsubscribe();
      }
      // invalida o token: qualquer loop/handler em voo se encerra sozinho
      this.currentDebugJob = null;
      this.debugLoopToken = null;

      if ( this.worker != null ){
        this.worker.terminate();
        this.worker = null;
      }
      if ( this.debugStatusInterval != null){
        clearInterval(this.debugStatusInterval);
      }

      if  ( this.subFile!=null){
        this.subFile.unsubscribe();
      }
  }

  resolveFlow(sql:Object[]){
    this.listOfVersion = [];
    for ( var item of sql as Object[]){ 
        this.listOfVersion.push({
            sequence:item['SEQUENCE'],
            active:item['ACTIVE'],
            versionDate:item['DTFORCE'],
            name:item['NAME'],
            expression:item['EXPRESSION'],
            lastChange: item['RECMODIFYON'],
            status:item['ACTIVE'] == "S" && item['DTFORCE']!=null ? "ACTIVE" : 
                    item['ACTIVE'] == "N" && item['DTFORCE']!=null ? "DEPRECATED" : "DRAFT"
        });
      }
  }
  
  ngOnInit(): void {
      
      this.flowData = {
        codecompany:this.selectedItem == null? 0 :this.selectedItem['CODECOMPANY'],
        codemktp: this.selectedItem == null? 3 :this.selectedItem['CODEMKTP'],
        codemktpdest: this.selectedItem == null? 3 :this.selectedItem['CODEMKTPDEST'],
        environment:1,
        idconf:this.selectedItem == null? 5162:this.selectedItem['IDCONF'],
        data:null,
        status:null
      };

      if ( this.sessionId == null ){
        this.sessionId = StringUtils.UIDGerador();
      }
      
      if ( this.idconf!= null ){
        this.flowData.idconf = this.idconf;
        if ( this.sequence != null ){
          this.flowData.sequence = this.sequence;
        }
      }
      
      this.flowLoading = true;

      this.workFlowService.loadFlow(this.flowData.idconf).then(async (sql:Object[])=>{

          if ( sql.length == 0 ){
            await this.saveFlow(true);
          }

          this.resolveFlow(sql);
          
          let activeIndex =  this.listOfVersion.findIndex(d=>d.active=="S");

          if ( this.sequence != null ){
            activeIndex = this.listOfVersion.findIndex(d=>d.sequence == this.sequence);
          }
          
          if ( activeIndex == -1 ){
            activeIndex = this.listOfVersion.findIndex(d=>(d.active =="N" || d.active == null) && d.versionDate == null);
          }

          if ( activeIndex == -1 ){  
              let version:Version ={
                  sequence:1,
                  active:'N',
                  versionDate:null,
                  expression:null,
                  status:'DRAFT',
                  lastChange:'1900-01-01',
                  name:this.ls.instant('workflow.version.noname')
              }
              this.activeFlow(version);
          }else{
            let activeVersion = this.listOfVersion[activeIndex];
            this.activeFlow(activeVersion);
          }
          
          this.workFlowService.loadConfigurations().then((con:any)=>{
            for ( var line of con as Object[]){
                this.configurations.push({
                    name: line['NAME'],
                    layout: JSON.parse(line['TEXT'])
                });
            }
            this.flowLoading = false;
          }).catch(error=>{
            this.flowLoading = false;
            this.messageService.error(error.message);
          });
          
      }).catch(error=>{
          this.flowLoading = false;
          this.messageService.error(error.message);
      });
  }

  fetchDataDebug(idjob?:number){
    return new Promise(async (resolve,reject)=>{
        await this.workFlowService.loadStatus(idjob==null? this.debugging.idjob : idjob).then(data=>{
          // o worker pode ter sido encerrado enquanto a requisição estava em voo
          if ( this.worker != null ){
            this.worker.postMessage(data);
          }
          resolve(data)
      }).catch(err=>reject(err));

    });

  }

  async createWorkerDebug() {

    if (typeof Worker === 'undefined') {
      console.log("Não suportado Worker");
      return;
    }

    // encerra o worker da execução anterior: handlers órfãos escreveriam
    // logs do job antigo sobre o debug corrente
    if ( this.worker != null ){
      this.worker.terminate();
    }

    this.currentDebugJob = this.debugging != null ? this.debugging.idjob : null;
    const jobToken = this.currentDebugJob;

    this.worker = new Worker(new URL('./webhook-edit-debug.component.worker', import.meta.url));
    this.worker.onmessage = ({ data }) => {

        // pacote de uma execução que já não é a corrente
        if ( data == null || this.debugging == null || this.currentDebugJob !== jobToken ){
          return;
        }

        this.debugging.status = data.status;
        this.debugging.log = data.log;
        this.changeDebuggingStatus();
        this.debugServices.updateDebug(this.debugging);
        // cada pacote já preserva os logs: se a execução terminar agora,
        // os ícones dos nós continuam com o último resultado
        this.lastDebugging = JSON.parse(JSON.stringify(this.debugging));
        this._changeDetectorRef.detectChanges();
    };

    // sem guarda de flag: o token já garante um loop por execução — e um
    // loop anterior travado não pode mais impedir o novo de iniciar
    if ( this.debug ) {
        this.debugStatusLoop();
    }

    // this.debugStatusInterval = setInterval(async () => {

    //   if ( this.debugging.debugging != 'STOPPED' ){
    //     await this.fetchDataDebug(this.debugging.idjob);
    //   }else{
       
    //     this.lastDebugging = JSON.parse(JSON.stringify(this.debugging));
    //     let withErrors = this.flowWithErrors(this.lastDebugging);
    //     let title = this.ls.instant('workflow.debug.stopped')
    //     let message = this.ls.instant(withErrors?'workflow.debug.stopped.message.comerros':'workflow.debug.stopped.message.semerros',{idjob:this.lastDebugging.idjob})
    //     this.notification.create(withErrors?'warning':'success',title,message);
    //     this.clearDebugging();
        
    //   }
      
    // },1000);

  }


  private async debugStatusLoop() {

    const jobToken = this.currentDebugJob;
    this.debugLoopToken = jobToken;
    this.isCheckingDebug = true;
    let failures = 0;
    let lastError = null;

    try {
      while ( this.currentDebugJob === jobToken
              && this.debugging != null
              && this.debugging.debugging !== 'STOPPED' ) {

        let ok = true;
        await this.fetchDataDebug(this.debugging.idjob).catch(error=>{
            ok = false;
            lastError = error;
        });

        if ( ok ){
          failures = 0;
        }else{
          failures++;
          // falhas seguidas: encerra o acompanhamento em vez de martelar o servidor
          if ( failures >= 3 ){
            this.messageService.error(GlobalErrorHandler.getMessage(lastError));
            break;
          }
        }

        await new Promise(res => setTimeout(res, 1000)); // pausa controlada
      }
    } finally {
      // só libera a trava se outro loop não assumiu no meio tempo
      if ( this.debugLoopToken === jobToken ){
        this.debugLoopToken = null;
        this.isCheckingDebug = false;
      }
    }

    // outra execução pode ter começado enquanto este loop rodava
    if ( this.currentDebugJob === jobToken ){
      this.finishDebug();
    }
  }

  /** encerra a execução corrente preservando os logs já recebidos */
  private finishDebug(){

    if ( this.currentDebugJob == null ){
      return; // já finalizada
    }
    this.currentDebugJob = null;

    // NUNCA sobrescrever com null: lastDebugging é o que mantém os
    // ícones de log nos nós depois que a execução termina
    if ( this.debugging != null ){
      this.lastDebugging = JSON.parse(JSON.stringify(this.debugging));
    }

    const withErrors = this.flowWithErrors(this.lastDebugging);

    const title = this.ls.instant('workflow.debug.stopped');
    const message = this.ls.instant(
      withErrors ? 'workflow.debug.stopped.message.comerros'
                : 'workflow.debug.stopped.message.semerros',
      { idjob: this.lastDebugging?.idjob }
    );

    this.notification.create(withErrors ? 'warning' : 'success', title, message);
    this.clearDebugging();
  }


  flowWithErrors(lastDebugging: DebugInterface):Boolean {
      return lastDebugging?.status?.error;
  }

  clearDebugging(){
      if ( this.worker != null ){
        this.worker.terminate();
        this.worker = null;
      }
      clearInterval(this.debugStatusInterval);
      this.debugging = null;
      this._changeDetectorRef.detectChanges();
  }


  changeDebuggingStatus() {
    // uma parada pedida localmente não pode ser desfeita por um pacote
    // de status que já estava em voo
    if ( this.debugging.debugging == 'STOPPED' ){
      return;
    }

    if ( this.debugging.status!=null){
      if ( this.debugging.status.status!=null){
          this.debugging.debugging = this.debugging.status.status;
      }
    }
  }
  

  activeFlow(version:Version){
    
    this.selectedVersion = version;
    
    this.flowData.sequence = version.sequence;
    this.flowData.active = version.active;
    this.flowData.status = version.status;
    this.flowData.name = version.name;
    
    if ( version.expression != null){
        this.flowData.data = JSON.parse(version.expression) as Flow;
        this.nodes = this.flowData.data.steps as NodeViewModel[];
        this.connections = this.flowData.data.connectors as ConnectorModel[];
        this.pruneOrphanConnections();
    }
    this._changeDetectorRef.detectChanges();
    this.centerCanvas(false);
  }

  getConnectionName(fromId:string){
    if ( fromId.endsWith("-true")){
      return "true";
    }else if ( fromId.endsWith("-false")){
      return "false";
    }else{
      return "";
    }
  }


  onFileSelected(event: Event): void {
    
    const input = event.target as HTMLInputElement;
    if (input.files?.length) {
      this.fileLoader.readFile(input.files[0]);
    }
  }


  openAIAssistant(){
      
      this.drawerRefIA = this.drawerService.create({
          nzPlacement:'bottom',
          nzTitle: this.ls.instant('webhook.ia.assistant.title.flowcreator')+ ' - '+ this.sessionId,
          nzContent: WebhookAIAssistantComponent,
          nzMask:false,
          nzMaskClosable: true,
          nzKeyboard: true,  
          nzClosable: true,
          nzBodyStyle: { overflow: 'auto',  display: 'flex','flex-direction': 'column', height: '100%' },
          nzData: {
              sessionId: this.sessionId,
              nodes: this.nodes,
              connections: this.connections,
              version: this.selectedVersion,
              idconf: this.idconf,
              user: this.uas
          },
          nzFooter:null
      });

      this.subIA = this.drawerRefIA.afterClose.subscribe((data) => {
          if ( data != null ){
            this.modal.confirm(
              {
                nzTitle: this.ls.instant('webhook.ia.assistant.flowcreator.import.title'),
                nzContent: this.ls.instant('webhook.ia.assistant.flowcreator.import.question'),
                nzOkText: this.ls.instant('confirm'),
                nzOkDanger: true,
                nzCancelText: this.ls.instant('cancel'),
                nzOnOk: () => { 
                  return new Promise((resolve) => {
                    try{
                        console.log(data);
                        let newData = JSON.parse(data);
                        if ( this.selectedVersion.status != "DRAFT" ){
                          this.saveFlow(true, newData.steps, newData.connectors).then(d=>{
                            resolve(true);
                          });
                        }else{
                          this.saveFlow(false, newData.steps, newData.connectors).then(d=>{
                            resolve(true);
                          });
                        }
                      }catch(exception){
                        this.messageService.error(this.ls.instant('webhook.ia.assistant.flowcreator.invalidjson'));
                      }
                  });
                }
              });
        }
      
      });
    } 


  protected onZoomIn(): void {
    console.log('fZoom instance:', this.fZoom);
    this.fZoom?.zoomIn();
  }

  protected onZoomOut(): void {
    this.fZoom?.zoomOut();
  }

  protected onZoomOnMouseWheelChanged(checked: boolean): void {
    this.isZoomEnabled = checked;
  }



    // ============================================================
  // FIX Foblex: conectores órfãos ao mudar id de componente
  // Substituir/adicionar estes métodos no WebhookEditComponent
  // ============================================================
  
  /** Detecção robusta de IF: aceita tanto a CHAVE do enum ('If') quanto o VALOR ('IF'). */
  private isIfType(type: any): boolean {
    return type === WorkFlowCreatorNodeType.If
        || WorkFlowCreatorNodeType[type] === WorkFlowCreatorNodeType.If;
  }
  
  /** createOutputNode corrigido — funciona no addNode E no paste. */
  createOutputNode(id: string, dataType: any) {
    if (this.isIfType(dataType)) {
      return [id + '_out-right-true', id + '_out-right-false'];
    }
    return [id + '_out-top', id + '_out-bottom', id + '_out-left', id + '_out-right'];
  }
  
  /**
   * Reescreve um id de porta trocando o prefixo (key do node), preservando
   * o sufixo: "OLD_out-right-true" -> "NEW_out-right-true".
   * Retorna null se o id não pertence a nenhuma key do mapa.
   */
  private remapPortId(portId: string, idMap: Map<string, string>): string | null {
    const sep = portId.indexOf('_');
    const nodeKey = sep >= 0 ? portId.substring(0, sep) : portId;
    const suffix = sep >= 0 ? portId.substring(sep) : '';
    const newKey = idMap.get(nodeKey);
    return newKey != null ? newKey + suffix : null;
  }
  
  /**
   * PASTE corrigido:
   *  - clona de novo a cada paste (NUNCA muta o clipboard nem reusa referência)
   *  - regenera keys via idMap e remapeia parentId de grupos copiados juntos
   *  - copia também as conexões INTERNAS à seleção, remapeadas
   *  - remonta o canvas (cache do Foblex)
   */
  protected paste(): void {
    const clip = this.clipboard();
    if (!clip?.length) return;
  
    const offset = 40;
    const pasted: NodeViewModel[] = ObjectUtil.deepClone(clip); // clone POR paste
    const idMap = new Map<string, string>();
  
    for (const node of pasted) {
      const newKey = StringUtils.UIDGerador();
      idMap.set(node.key, newKey);
      node.key = newKey;
    }
  
    for (const node of pasted) {
      node.outputs = this.createOutputNode(node.key, node.type);
      node.inputs = this.createInputNode(node.key);
      node.name = this.ls.instant('copy') + ' ' + this.ls.instant('of') + ' ' + node.name;
      node.position = { x: node.position.x + offset, y: node.position.y + offset };
  
      // grupo copiado junto com filhos: remapeia; senão, solta do grupo antigo
      if (node.parentId != null) {
        node.parentId = idMap.get(node.parentId) ?? undefined;
      }
      this.nodes.push(node);
    }
  
    // conexões cujo from E to pertencem à seleção copiada
    const copiedConnections: ConnectorModel[] = [];
    for (const conn of this.connections) {
      const newFrom = this.remapPortId(conn.from, idMap);
      const newTo = this.remapPortId(conn.to, idMap);
      if (newFrom != null && newTo != null) {
        const cloned: ConnectorModel = ObjectUtil.deepClone(conn);
        // preserva o sufixo -true/-false da key (semântica do IF)
        const keySuffix = conn.key.endsWith('-true') ? '-true'
                        : conn.key.endsWith('-false') ? '-false' : '';
        cloned.key = StringUtils.UIDGerador() + keySuffix;
        cloned.from = newFrom;
        cloned.to = newTo;
        copiedConnections.push(cloned);
      }
    }
    this.connections.push(...copiedConnections);
  
    this.nodes = [...this.nodes];
    this.connections = [...this.connections];
    this.canSave = true;
    this.flowRef.clearSelection();
    this.reloadFlow(); // remonta o <f-flow>: evita o cache de IDs do Foblex
  }
  
  /**
   * Poda conexões órfãs: from/to cujo node não existe mais.
   * Uma única órfã derruba o render do Foblex com "Output with id ... not found".
   * Chamar após activeFlow(), import de arquivo e import do assistente de IA.
   */
  private pruneOrphanConnections(): void {
    if (!this.nodes?.length || !this.connections?.length) return;

    const keys = this.nodes.map(n => n.key);

    const kept = this.connections.filter(conn =>
      conn.from != null && conn.to != null &&
      keys.some(k => conn.from.startsWith(k)) &&
      keys.some(k => conn.to.startsWith(k))
    );

    if (kept.length === 0 && this.connections.length > 0) {
      console.warn('pruneOrphanConnections: poda removeria TODAS as conexões — abortada.',
        { exemploFrom: this.connections[0]?.from, exemploKeys: keys.slice(0, 3) });
      return;
    }

    if (kept.length !== this.connections.length) {
      console.warn(`pruneOrphanConnections: removidas ${this.connections.length - kept.length} órfã(s)`);
      this.connections = kept;
    }
  }
}
